import { Image } from 'antd-mobile'
import { AddSquareOutline } from 'antd-mobile-icons'
import { isEmpty } from 'lodash-es'
import { toJS } from 'mobx'
import { observer, useLocalObservable } from 'mobx-react-lite'
import React from 'react'

import jobStore from '@/store/components/entryJob'

import { HBlockAdd } from '../../HYBVant'

import Popup from './Popup'
import useHealth from './useHealth'
import useLocalHealth from './useLocalHealth'

import './index.less'

interface IHealthCertificate {
  onConfirm?: (data: any) => void
  isLocalObserver?: boolean
  isAuth?: boolean
}
const HealthCertificate: React.FC<IHealthCertificate> = ({
  onConfirm,
  isLocalObserver,
  isAuth = true
}) => {
  const {
    employeeIds,
    healthCertificate = [],
    changeHealthCertificateStatus,
    changeAllHealthCertificate,
    changeEditHealthItem
  } = useLocalObservable(() => jobStore)
  const local = useLocalHealth({
    onConfirm,
    employeeIds,
    healthCertificate,
    changeHealthCertificateStatus,
    changeAllHealthCertificate,
    changeEditHealthItem
  })
  const remote = useHealth({
    onConfirm,
    employeeIds,
    healthCertificate,
    changeHealthCertificateStatus,
    changeAllHealthCertificate,
    changeEditHealthItem
  })
  const {
    add,
    edit,
    open,
    modalData,
    onCancel,
    runSaveHealth,
    runDeleteHrmHealth,
    runHhealthsEmployee,
    saveHealthLoading,
    deleteHrmHealthLoading
  } = isLocalObserver ? local : remote
  console.log('healthCertificate', toJS(healthCertificate))
  return (
    <div className='health_certificate'>
      {!isEmpty(healthCertificate) && (
        <div className='health_certificate-content-wrapper'>
          {healthCertificate?.map((x: any, index: number) => (
            <div
              key={`${x?.id}-${index}`}
              className='health_certificate-content'
              onClick={() => isAuth && edit(index)}
            >
              <div className='health_certificate-content-col-1'>
                <div className='health_certificate-content-1'>
                  {x?.city_names?.join('/') || '-'}
                </div>
                <div className='health_certificate-content-3'>
                  {x?.health_start_at || '-'}&nbsp;&nbsp;至&nbsp;&nbsp;{x?.health_end_at || '-'}
                </div>
              </div>
              <div className='health_certificate-content-col-2'>
                {isAuth && (
                  <Image
                    className='hyb-com-concat-content-col-2-img'
                    src='https://s.huiyunban.cn/1747191709529280512.png'
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {isAuth && <HBlockAdd onClick={add} text='添加健康证' />}
      {open && (
        <Popup
          visible={open}
          onCancel={onCancel}
          modalData={{
            ...modalData,
            runSaveHealth,
            runDeleteHrmHealth,
            runHhealthsEmployee,
            saveHealthLoading,
            deleteHrmHealthLoading
          }}
        />
      )}
    </div>
  )
}

export default observer(HealthCertificate)
